const triglyceride = {
  parameters: [
    {
      name: 'triglyceride',
      id: 'triglyceride',
      displayName: 'Triglyceride',
      validFrom: '2022/05/24 1:00',
      validThrough: null,
      interpretationsSupported: [
        'normal',
        'too-high',
        'fault',
      ],
      ranges: [{
        color: '#1f7359',
        description: 'triglyceride-normal',
        lowerLimit: 0,
        lowerLimitOperator: '>=',
        upperLimit: 2,
        upperLimitOperator: '<',
        unit: 'mmol/l',
        interpretation: 'normal',
        displayInterpretation: 'Normal',
        rangeInterpretation: '0 - 1.9',
      },
      {
        color: '#EF4036',
        description: 'triglyceride-too-high',
        lowerLimit: 2,
        lowerLimitOperator: '>=',
        upperLimit: 6,
        upperLimitOperator: '',
        unit: 'mmol/l',
        interpretation: 'too-high',
        displayInterpretation: 'Too high',
        rangeInterpretation: '>= 2',
      }],
    },
  ],
};

export default triglyceride;